import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { PDFViewWebMode } from '../../components/PDFViewWebMode';
import { FormData, Vehicle, Victim, Street } from '../../@types/SinisterFormTypes';
import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { useStyles } from './styles';
import { CircularProgress } from '@material-ui/core';

interface IncidentImages {
  path: string;
  uuid: string;
  description: string;
}

const BolletinViewer: React.FC = () => {
  const { pathId } = useParams<{ pathId: string }>();
  const styles = useStyles();

  const [showWeb, setShowWeb] = useState<boolean>(true);
  const [showPdf, setShowPdf] = useState<boolean>(false);
  const [images, setImagens] = useState<IncidentImages[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [vehicles, setVehicles] = useState<Vehicle[]>([]);
  const [street, setStreet] = useState<Street[]>([]);
  const [victim, setVictim] = useState<Victim[]>([]);
  const [register, setRegister] = useState<FormData>({
    uuid: '',
    city: '',
    created: '',
    data: {
      driverVeiculo: vehicles,
      driverVia: street,
      driverVitima: victim,
      driverIncidenteDetails: {
        'Controle de Tráfego': '',

        'Código do Acidente': '',
        'Elementos Atingidas': '',
        'Endereço 1': '',
        'Endereço 2': '',
        'Hora informada': '',
        Iluminação: '',
        Interseção: '',
        Jurisdição: '',
        Local: '',
        Natureza: '',
        'Ocorrido ao Longo da Via/Cruzamento': '',
        'Primeira Fonte de Informação': '',
        Severidade: '',
        'Superfície da Pista': '',
        Tempo: '',
        'Tipo de Cruzamento': '',
        'Notas Gerais': '',
      },
      driverAgentsAndVehicles: {
        agents: [],
        missionCars: [],
        'Serviços Acionados': [],
        _localId: '',
      },
    },
    geom: {
      coordinates: [0, 0],
      type: 'Point',
    },
    location_text: '',
    occurred_from: '',
    occurred_to: '',
    road: '',
    schema: '',
    state: '',
  });

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${process.env.REACT_APP_HIGH_CLASS_AUTH_TOKKEN}` };
  }, []);
  console.log('authHeader', authHeader);

  const arrayImagens = useCallback(async () => {
    const { data: file } = await api.get<IncidentImages[]>(
      '/api/incident_records/get_images/',
      {
        headers: authHeader,
        params: {
          recordID: pathId,
        },
      },
    );
    setImagens(file);
  }, [authHeader, pathId]);

  useEffect(() => {
    async function loadRegister(id: string) {
      setLoading(true);

      const registers = await api.get(`/api/incident_records/${id}/`, {
        headers: authHeader,
        params: {
          details_only: 'False',
        },
      });
      setRegister(registers.data);
    }
    loadRegister(pathId);
    arrayImagens();
    if (register.created !== '') {
      setLoading(false);
    }
  }, [pathId, authHeader, register.created, arrayImagens]);

  return (
    <div className={styles.container}>
      {/* <div className="Menu">
        <nav className="navbar">
          <button
            className="MenuButton"
            onClick={() => {
              setShowWeb((prev) => !prev);
              setShowPdf(false);
            }}
          >
            {showWeb ? "Ocultar Web" : "Ver Web"}
          </button>

          <button
            className="MenuButton"
            onClick={() => {
              setShowPdf((prev) => !prev);
              setShowWeb(false);
            }}
          >
            {showPdf ? "Ocultar PDF" : "Ver PDF"}
          </button>

          <button className="MenuButton">PDF Download</button>
        </nav>
      </div> */}

      {loading ? (
        <div className={styles.loadingContainer}>
          <CircularProgress className={styles.loadingSpinner} size={60} thickness={5} />
        </div>
      ) : (
        <div className={styles.content}>
          {showWeb && <PDFViewWebMode sinistro={register} sinistroImagens={images} />}
          {/* {showPdf && <p>PDF page</p>} */}
        </div>
      )}
    </div>
  );
};

export default BolletinViewer;
